import { useInput } from "react-admin";
import { type FilterMode, FILTER_MODE_SUFFIX } from "../backoffice.utils";
import { SegmentedControl } from "../misc/SegmentedControl";

const filterModeOptions: Array<{ value: FilterMode; label: string }> = [
  { value: "included", label: "enthält" },
  { value: "excluded", label: "enthält nicht" },
];

export function FilterModeDropdownMenu(props: { source: string }) {
  const { source } = props;
  const modeSource = `${source}${FILTER_MODE_SUFFIX}`;
  const { field } = useInput({ source: modeSource, defaultValue: filterModeOptions[0].value });
  const mode: FilterMode = field.value === "excluded" ? "excluded" : "included";

  return (
    <SegmentedControl
      label="Filtermodus"
      options={filterModeOptions}
      value={mode}
      onChange={field.onChange}
      onBlur={field.onBlur}
    />
  );
}
